import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import Button from "../Button/Button";
import { useTranslation } from "react-i18next";
import { routes } from "../../routes/routes";
import styles from "./EventsNotStarted.module.css";

type EventNotStartedState = {
  poster?: string;
  title?: string;
  fallbackPath?: string;
};

const EventNotStarted = () => {
  const { t } = useTranslation("translations");
  const navigate = useNavigate();
  const { state } = useLocation();

  const { poster, title, fallbackPath = routes.sports } =
    (state as EventNotStartedState) || {};

  const handleBack = () => {
    const canGoBack = (window.history.state?.idx ?? 0) > 0;

    if (canGoBack) {
      navigate(-1);
      return;
    }

    navigate(fallbackPath || routes.sports);
  };

  return (
    <Box
      className={styles.container}
      style={{ backgroundImage: `url(${poster || ""})` }}
    >
      {/* Overlay */}
      <Box className={styles.overlay} />

      {/* Content */}
      <Box className={styles.content}>
        <Typography variant="h1" className={styles.title}>
          {title}
        </Typography>

        <Typography variant="h3" className={styles.subtitle}>
          {t("NotFound.notStarted")}
        </Typography>

        <Button
          variant="contained"
          color="secondary"
          onClick={handleBack}
        >
          {t("Buttons.back")}
        </Button>
      </Box>
    </Box>
  );
};

export default EventNotStarted;
